export default __webpack_public_path__ + "static/media/data-points-icon.b306de1b.svg";